/* tslint:disable */
/* eslint-disable */
/**
 * Marsinet API
 * Esta API es utilizada tanto por Marsinet como por MarsiConnect. Proporciona todos los endpoints actualizados y documentación detallada, incluyendo ejemplos de datos y mocks de prueba para verificar el comportamiento de cada llamada.
 *
 * OpenAPI spec version: 5.0.1
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import globalAxios, {
  AxiosResponse,
  AxiosInstance,
  AxiosRequestConfig,
} from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import {
  BASE_PATH,
  COLLECTION_FORMATS,
  RequestArgs,
  BaseAPI,
  RequiredError,
} from '../base';
import { AssignableCreator } from '../models';
import { IncidentDetectedByOptionsResponseDTO } from '../models';
import { Organization } from '../models';
import { SupportDTO } from '../models';
import { ToggleUserActiveDto } from '../models';
import { UserPrivacyDTO } from '../models';
import { UsersView } from '../models';
/**
 * UsersApi - axios parameter creator
 * @export
 */
export const UsersApiAxiosParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     *
     * @summary Retrieves all users
     * @param {string} [page] Page number (default: 1)
     * @param {string} [limit] Number of items per page (default: 10)
     * @param {string} [search] The search term for filtering users
     * @param {string} [sort_field] The field to sort by
     * @param {string} [sort_order] The order to sort by (asc or desc)
     * @param {boolean} [pending_verification] Return users pending email verification
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    usersControllerFindAll: async (
      page?: string,
      limit?: string,
      search?: string,
      sort_field?: string,
      sort_order?: string,
      pending_verification?: boolean,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/users`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions: AxiosRequestConfig = {
        method: 'GET',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication JWT required
      // http bearer authentication required
      if (configuration && configuration.accessToken) {
        const accessToken =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken()
            : await configuration.accessToken;
        localVarHeaderParameter['Authorization'] = 'Bearer ' + accessToken;
      }

      if (page !== undefined) {
        localVarQueryParameter['page'] = page;
      }

      if (limit !== undefined) {
        localVarQueryParameter['limit'] = limit;
      }

      if (search !== undefined) {
        localVarQueryParameter['search'] = search;
      }

      if (sort_field !== undefined) {
        localVarQueryParameter['sortField'] = sort_field;
      }

      if (sort_order !== undefined) {
        localVarQueryParameter['sortOrder'] = sort_order;
      }

      if (pending_verification !== undefined) {
        localVarQueryParameter['pendingVerification'] = pending_verification;
      }

      const query = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        query.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.params) {
        query.set(key, options.params[key]);
      }
      localVarUrlObj.search = new URLSearchParams(query).toString();
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Lists users that can be assigned as the creator of an organization
     * @param {string} organization_id Organization whose creator is being updated (its users are excluded)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    usersControllerGetAvailableOrganizationCreators: async (
      organization_id: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'organization_id' is not null or undefined
      if (organization_id === null || organization_id === undefined) {
        throw new RequiredError(
          'organization_id',
          'Required parameter organization_id was null or undefined when calling usersControllerGetAvailableOrganizationCreators.'
        );
      }
      const localVarPath = `/users/organization/available-creators`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions: AxiosRequestConfig = {
        method: 'GET',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication JWT required
      // http bearer authentication required
      if (configuration && configuration.accessToken) {
        const accessToken =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken()
            : await configuration.accessToken;
        localVarHeaderParameter['Authorization'] = 'Bearer ' + accessToken;
      }

      if (organization_id !== undefined) {
        localVarQueryParameter['organizationId'] = organization_id;
      }

      const query = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        query.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.params) {
        query.set(key, options.params[key]);
      }
      localVarUrlObj.search = new URLSearchParams(query).toString();
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Retrieves detected-by options for incidents from current user organization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    usersControllerGetIncidentDetectedByOptions: async (
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/users/incidents/detected-by-options`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions: AxiosRequestConfig = {
        method: 'GET',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication JWT required
      // http bearer authentication required
      if (configuration && configuration.accessToken) {
        const accessToken =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken()
            : await configuration.accessToken;
        localVarHeaderParameter['Authorization'] = 'Bearer ' + accessToken;
      }

      const query = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        query.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.params) {
        query.set(key, options.params[key]);
      }
      localVarUrlObj.search = new URLSearchParams(query).toString();
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Retrieves organization information
     * @param {string} id The unique identifier of the user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    usersControllerGetOrganization: async (
      id: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      if (id === null || id === undefined) {
        throw new RequiredError(
          'id',
          'Required parameter id was null or undefined when calling usersControllerGetOrganization.'
        );
      }
      const localVarPath = `/users/organizations/{id}`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions: AxiosRequestConfig = {
        method: 'GET',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication JWT required
      // http bearer authentication required
      if (configuration && configuration.accessToken) {
        const accessToken =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken()
            : await configuration.accessToken;
        localVarHeaderParameter['Authorization'] = 'Bearer ' + accessToken;
      }

      const query = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        query.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.params) {
        query.set(key, options.params[key]);
      }
      localVarUrlObj.search = new URLSearchParams(query).toString();
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Retrieves organizations associated with an MNT organization from a mnt user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    usersControllerGetOrganizations: async (
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/users/organizations`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions: AxiosRequestConfig = {
        method: 'GET',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication JWT required
      // http bearer authentication required
      if (configuration && configuration.accessToken) {
        const accessToken =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken()
            : await configuration.accessToken;
        localVarHeaderParameter['Authorization'] = 'Bearer ' + accessToken;
      }

      const query = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        query.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.params) {
        query.set(key, options.params[key]);
      }
      localVarUrlObj.search = new URLSearchParams(query).toString();
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Search all admin User in organization and select a contact data
     * @param {string} o_id Organization id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    usersControllerGetUsersOrganization: async (
      o_id: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'o_id' is not null or undefined
      if (o_id === null || o_id === undefined) {
        throw new RequiredError(
          'o_id',
          'Required parameter o_id was null or undefined when calling usersControllerGetUsersOrganization.'
        );
      }
      const localVarPath = `/users/user/userdata/{o_id}`.replace(
        `{${'o_id'}}`,
        encodeURIComponent(String(o_id))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions: AxiosRequestConfig = {
        method: 'GET',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication JWT required
      // http bearer authentication required
      if (configuration && configuration.accessToken) {
        const accessToken =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken()
            : await configuration.accessToken;
        localVarHeaderParameter['Authorization'] = 'Bearer ' + accessToken;
      }

      const query = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        query.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.params) {
        query.set(key, options.params[key]);
      }
      localVarUrlObj.search = new URLSearchParams(query).toString();
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Send email to support team
     * @param {SupportDTO} body Support email data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    usersControllerSendSupportEmail: async (
      body: SupportDTO,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'body' is not null or undefined
      if (body === null || body === undefined) {
        throw new RequiredError(
          'body',
          'Required parameter body was null or undefined when calling usersControllerSendSupportEmail.'
        );
      }
      const localVarPath = `/users/support/messages`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions: AxiosRequestConfig = {
        method: 'POST',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication JWT required
      // http bearer authentication required
      if (configuration && configuration.accessToken) {
        const accessToken =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken()
            : await configuration.accessToken;
        localVarHeaderParameter['Authorization'] = 'Bearer ' + accessToken;
      }

      localVarHeaderParameter['Content-Type'] = 'application/json';

      const query = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        query.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.params) {
        query.set(key, options.params[key]);
      }
      localVarUrlObj.search = new URLSearchParams(query).toString();
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      const needsSerialization =
        typeof body !== 'string' ||
        localVarRequestOptions.headers['Content-Type'] === 'application/json';
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(body !== undefined ? body : {})
        : body || '';

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Activa o desactiva un usuario
     * @param {ToggleUserActiveDto} body DTO con el estado activo
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    usersControllerToggleUserActive: async (
      body: ToggleUserActiveDto,
      id: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'body' is not null or undefined
      if (body === null || body === undefined) {
        throw new RequiredError(
          'body',
          'Required parameter body was null or undefined when calling usersControllerToggleUserActive.'
        );
      }
      // verify required parameter 'id' is not null or undefined
      if (id === null || id === undefined) {
        throw new RequiredError(
          'id',
          'Required parameter id was null or undefined when calling usersControllerToggleUserActive.'
        );
      }
      const localVarPath = `/users/active/{id}`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions: AxiosRequestConfig = {
        method: 'PATCH',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication JWT required
      // http bearer authentication required
      if (configuration && configuration.accessToken) {
        const accessToken =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken()
            : await configuration.accessToken;
        localVarHeaderParameter['Authorization'] = 'Bearer ' + accessToken;
      }

      localVarHeaderParameter['Content-Type'] = 'application/json';

      const query = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        query.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.params) {
        query.set(key, options.params[key]);
      }
      localVarUrlObj.search = new URLSearchParams(query).toString();
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      const needsSerialization =
        typeof body !== 'string' ||
        localVarRequestOptions.headers['Content-Type'] === 'application/json';
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(body !== undefined ? body : {})
        : body || '';

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Updates privacy settings for a user
     * @param {UserPrivacyDTO} body User privacy settings data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    usersControllerUpdatePrivacySettings: async (
      body: UserPrivacyDTO,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'body' is not null or undefined
      if (body === null || body === undefined) {
        throw new RequiredError(
          'body',
          'Required parameter body was null or undefined when calling usersControllerUpdatePrivacySettings.'
        );
      }
      const localVarPath = `/users/privacy`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions: AxiosRequestConfig = {
        method: 'PATCH',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication JWT required
      // http bearer authentication required
      if (configuration && configuration.accessToken) {
        const accessToken =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken()
            : await configuration.accessToken;
        localVarHeaderParameter['Authorization'] = 'Bearer ' + accessToken;
      }

      localVarHeaderParameter['Content-Type'] = 'application/json';

      const query = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        query.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.params) {
        query.set(key, options.params[key]);
      }
      localVarUrlObj.search = new URLSearchParams(query).toString();
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      const needsSerialization =
        typeof body !== 'string' ||
        localVarRequestOptions.headers['Content-Type'] === 'application/json';
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(body !== undefined ? body : {})
        : body || '';

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Update the user to give them the admin role
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    usersControllerUpdateUserToAdmin: async (
      id: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      if (id === null || id === undefined) {
        throw new RequiredError(
          'id',
          'Required parameter id was null or undefined when calling usersControllerUpdateUserToAdmin.'
        );
      }
      const localVarPath = `/users/admin/{id}`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions: AxiosRequestConfig = {
        method: 'PATCH',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication JWT required
      // http bearer authentication required
      if (configuration && configuration.accessToken) {
        const accessToken =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken()
            : await configuration.accessToken;
        localVarHeaderParameter['Authorization'] = 'Bearer ' + accessToken;
      }

      const query = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        query.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.params) {
        query.set(key, options.params[key]);
      }
      localVarUrlObj.search = new URLSearchParams(query).toString();
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * UsersApi - functional programming interface
 * @export
 */
export const UsersApiFp = function (configuration?: Configuration) {
  return {
    /**
     *
     * @summary Retrieves all users
     * @param {string} [page] Page number (default: 1)
     * @param {string} [limit] Number of items per page (default: 10)
     * @param {string} [search] The search term for filtering users
     * @param {string} [sort_field] The field to sort by
     * @param {string} [sort_order] The order to sort by (asc or desc)
     * @param {boolean} [pending_verification] Return users pending email verification
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async usersControllerFindAll(
      page?: string,
      limit?: string,
      search?: string,
      sort_field?: string,
      sort_order?: string,
      pending_verification?: boolean,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => Promise<AxiosResponse<UsersView>>
    > {
      const localVarAxiosArgs = await UsersApiAxiosParamCreator(
        configuration
      ).usersControllerFindAll(
        page,
        limit,
        search,
        sort_field,
        sort_order,
        pending_verification,
        options
      );
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs: AxiosRequestConfig = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @summary Lists users that can be assigned as the creator of an organization
     * @param {string} organization_id Organization whose creator is being updated (its users are excluded)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async usersControllerGetAvailableOrganizationCreators(
      organization_id: string,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => Promise<AxiosResponse<Array<AssignableCreator>>>
    > {
      const localVarAxiosArgs = await UsersApiAxiosParamCreator(
        configuration
      ).usersControllerGetAvailableOrganizationCreators(
        organization_id,
        options
      );
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs: AxiosRequestConfig = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @summary Retrieves detected-by options for incidents from current user organization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async usersControllerGetIncidentDetectedByOptions(
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => Promise<AxiosResponse<IncidentDetectedByOptionsResponseDTO>>
    > {
      const localVarAxiosArgs =
        await UsersApiAxiosParamCreator(
          configuration
        ).usersControllerGetIncidentDetectedByOptions(options);
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs: AxiosRequestConfig = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @summary Retrieves organization information
     * @param {string} id The unique identifier of the user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async usersControllerGetOrganization(
      id: string,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => Promise<AxiosResponse<Organization>>
    > {
      const localVarAxiosArgs = await UsersApiAxiosParamCreator(
        configuration
      ).usersControllerGetOrganization(id, options);
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs: AxiosRequestConfig = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @summary Retrieves organizations associated with an MNT organization from a mnt user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async usersControllerGetOrganizations(
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => Promise<AxiosResponse<Array<Organization>>>
    > {
      const localVarAxiosArgs =
        await UsersApiAxiosParamCreator(
          configuration
        ).usersControllerGetOrganizations(options);
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs: AxiosRequestConfig = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @summary Search all admin User in organization and select a contact data
     * @param {string} o_id Organization id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async usersControllerGetUsersOrganization(
      o_id: string,
      options?: AxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<void>>
    > {
      const localVarAxiosArgs = await UsersApiAxiosParamCreator(
        configuration
      ).usersControllerGetUsersOrganization(o_id, options);
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs: AxiosRequestConfig = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @summary Send email to support team
     * @param {SupportDTO} body Support email data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async usersControllerSendSupportEmail(
      body: SupportDTO,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => Promise<AxiosResponse<boolean>>
    > {
      const localVarAxiosArgs = await UsersApiAxiosParamCreator(
        configuration
      ).usersControllerSendSupportEmail(body, options);
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs: AxiosRequestConfig = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @summary Activa o desactiva un usuario
     * @param {ToggleUserActiveDto} body DTO con el estado activo
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async usersControllerToggleUserActive(
      body: ToggleUserActiveDto,
      id: string,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => Promise<AxiosResponse<boolean>>
    > {
      const localVarAxiosArgs = await UsersApiAxiosParamCreator(
        configuration
      ).usersControllerToggleUserActive(body, id, options);
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs: AxiosRequestConfig = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @summary Updates privacy settings for a user
     * @param {UserPrivacyDTO} body User privacy settings data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async usersControllerUpdatePrivacySettings(
      body: UserPrivacyDTO,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => Promise<AxiosResponse<boolean>>
    > {
      const localVarAxiosArgs = await UsersApiAxiosParamCreator(
        configuration
      ).usersControllerUpdatePrivacySettings(body, options);
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs: AxiosRequestConfig = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @summary Update the user to give them the admin role
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async usersControllerUpdateUserToAdmin(
      id: string,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => Promise<AxiosResponse<boolean>>
    > {
      const localVarAxiosArgs = await UsersApiAxiosParamCreator(
        configuration
      ).usersControllerUpdateUserToAdmin(id, options);
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs: AxiosRequestConfig = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
  };
};

/**
 * UsersApi - factory interface
 * @export
 */
export const UsersApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  return {
    /**
     *
     * @summary Retrieves all users
     * @param {string} [page] Page number (default: 1)
     * @param {string} [limit] Number of items per page (default: 10)
     * @param {string} [search] The search term for filtering users
     * @param {string} [sort_field] The field to sort by
     * @param {string} [sort_order] The order to sort by (asc or desc)
     * @param {boolean} [pending_verification] Return users pending email verification
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async usersControllerFindAll(
      page?: string,
      limit?: string,
      search?: string,
      sort_field?: string,
      sort_order?: string,
      pending_verification?: boolean,
      options?: AxiosRequestConfig
    ): Promise<AxiosResponse<UsersView>> {
      return UsersApiFp(configuration)
        .usersControllerFindAll(
          page,
          limit,
          search,
          sort_field,
          sort_order,
          pending_verification,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Lists users that can be assigned as the creator of an organization
     * @param {string} organization_id Organization whose creator is being updated (its users are excluded)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async usersControllerGetAvailableOrganizationCreators(
      organization_id: string,
      options?: AxiosRequestConfig
    ): Promise<AxiosResponse<Array<AssignableCreator>>> {
      return UsersApiFp(configuration)
        .usersControllerGetAvailableOrganizationCreators(
          organization_id,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Retrieves detected-by options for incidents from current user organization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async usersControllerGetIncidentDetectedByOptions(
      options?: AxiosRequestConfig
    ): Promise<AxiosResponse<IncidentDetectedByOptionsResponseDTO>> {
      return UsersApiFp(configuration)
        .usersControllerGetIncidentDetectedByOptions(options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Retrieves organization information
     * @param {string} id The unique identifier of the user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async usersControllerGetOrganization(
      id: string,
      options?: AxiosRequestConfig
    ): Promise<AxiosResponse<Organization>> {
      return UsersApiFp(configuration)
        .usersControllerGetOrganization(id, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Retrieves organizations associated with an MNT organization from a mnt user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async usersControllerGetOrganizations(
      options?: AxiosRequestConfig
    ): Promise<AxiosResponse<Array<Organization>>> {
      return UsersApiFp(configuration)
        .usersControllerGetOrganizations(options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Search all admin User in organization and select a contact data
     * @param {string} o_id Organization id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async usersControllerGetUsersOrganization(
      o_id: string,
      options?: AxiosRequestConfig
    ): Promise<AxiosResponse<void>> {
      return UsersApiFp(configuration)
        .usersControllerGetUsersOrganization(o_id, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Send email to support team
     * @param {SupportDTO} body Support email data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async usersControllerSendSupportEmail(
      body: SupportDTO,
      options?: AxiosRequestConfig
    ): Promise<AxiosResponse<boolean>> {
      return UsersApiFp(configuration)
        .usersControllerSendSupportEmail(body, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Activa o desactiva un usuario
     * @param {ToggleUserActiveDto} body DTO con el estado activo
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async usersControllerToggleUserActive(
      body: ToggleUserActiveDto,
      id: string,
      options?: AxiosRequestConfig
    ): Promise<AxiosResponse<boolean>> {
      return UsersApiFp(configuration)
        .usersControllerToggleUserActive(body, id, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Updates privacy settings for a user
     * @param {UserPrivacyDTO} body User privacy settings data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async usersControllerUpdatePrivacySettings(
      body: UserPrivacyDTO,
      options?: AxiosRequestConfig
    ): Promise<AxiosResponse<boolean>> {
      return UsersApiFp(configuration)
        .usersControllerUpdatePrivacySettings(body, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Update the user to give them the admin role
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async usersControllerUpdateUserToAdmin(
      id: string,
      options?: AxiosRequestConfig
    ): Promise<AxiosResponse<boolean>> {
      return UsersApiFp(configuration)
        .usersControllerUpdateUserToAdmin(id, options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * UsersApi - object-oriented interface
 * @export
 * @class UsersApi
 * @extends {BaseAPI}
 */
export class UsersApi extends BaseAPI {
  /**
   *
   * @summary Retrieves all users
   * @param {string} [page] Page number (default: 1)
   * @param {string} [limit] Number of items per page (default: 10)
   * @param {string} [search] The search term for filtering users
   * @param {string} [sort_field] The field to sort by
   * @param {string} [sort_order] The order to sort by (asc or desc)
   * @param {boolean} [pending_verification] Return users pending email verification
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UsersApi
   */
  public async usersControllerFindAll(
    page?: string,
    limit?: string,
    search?: string,
    sort_field?: string,
    sort_order?: string,
    pending_verification?: boolean,
    options?: AxiosRequestConfig
  ): Promise<AxiosResponse<UsersView>> {
    return UsersApiFp(this.configuration)
      .usersControllerFindAll(
        page,
        limit,
        search,
        sort_field,
        sort_order,
        pending_verification,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @summary Lists users that can be assigned as the creator of an organization
   * @param {string} organization_id Organization whose creator is being updated (its users are excluded)
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UsersApi
   */
  public async usersControllerGetAvailableOrganizationCreators(
    organization_id: string,
    options?: AxiosRequestConfig
  ): Promise<AxiosResponse<Array<AssignableCreator>>> {
    return UsersApiFp(this.configuration)
      .usersControllerGetAvailableOrganizationCreators(organization_id, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @summary Retrieves detected-by options for incidents from current user organization
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UsersApi
   */
  public async usersControllerGetIncidentDetectedByOptions(
    options?: AxiosRequestConfig
  ): Promise<AxiosResponse<IncidentDetectedByOptionsResponseDTO>> {
    return UsersApiFp(this.configuration)
      .usersControllerGetIncidentDetectedByOptions(options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @summary Retrieves organization information
   * @param {string} id The unique identifier of the user
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UsersApi
   */
  public async usersControllerGetOrganization(
    id: string,
    options?: AxiosRequestConfig
  ): Promise<AxiosResponse<Organization>> {
    return UsersApiFp(this.configuration)
      .usersControllerGetOrganization(id, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @summary Retrieves organizations associated with an MNT organization from a mnt user
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UsersApi
   */
  public async usersControllerGetOrganizations(
    options?: AxiosRequestConfig
  ): Promise<AxiosResponse<Array<Organization>>> {
    return UsersApiFp(this.configuration)
      .usersControllerGetOrganizations(options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @summary Search all admin User in organization and select a contact data
   * @param {string} o_id Organization id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UsersApi
   */
  public async usersControllerGetUsersOrganization(
    o_id: string,
    options?: AxiosRequestConfig
  ): Promise<AxiosResponse<void>> {
    return UsersApiFp(this.configuration)
      .usersControllerGetUsersOrganization(o_id, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @summary Send email to support team
   * @param {SupportDTO} body Support email data
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UsersApi
   */
  public async usersControllerSendSupportEmail(
    body: SupportDTO,
    options?: AxiosRequestConfig
  ): Promise<AxiosResponse<boolean>> {
    return UsersApiFp(this.configuration)
      .usersControllerSendSupportEmail(body, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @summary Activa o desactiva un usuario
   * @param {ToggleUserActiveDto} body DTO con el estado activo
   * @param {string} id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UsersApi
   */
  public async usersControllerToggleUserActive(
    body: ToggleUserActiveDto,
    id: string,
    options?: AxiosRequestConfig
  ): Promise<AxiosResponse<boolean>> {
    return UsersApiFp(this.configuration)
      .usersControllerToggleUserActive(body, id, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @summary Updates privacy settings for a user
   * @param {UserPrivacyDTO} body User privacy settings data
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UsersApi
   */
  public async usersControllerUpdatePrivacySettings(
    body: UserPrivacyDTO,
    options?: AxiosRequestConfig
  ): Promise<AxiosResponse<boolean>> {
    return UsersApiFp(this.configuration)
      .usersControllerUpdatePrivacySettings(body, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @summary Update the user to give them the admin role
   * @param {string} id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UsersApi
   */
  public async usersControllerUpdateUserToAdmin(
    id: string,
    options?: AxiosRequestConfig
  ): Promise<AxiosResponse<boolean>> {
    return UsersApiFp(this.configuration)
      .usersControllerUpdateUserToAdmin(id, options)
      .then((request) => request(this.axios, this.basePath));
  }
}
